import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _43c1e4c5 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "" */))
const _4578860d = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "" */))
const _45513a1a = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _238d7bb5 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _4be7fc11 = () => interopDefault(import('../pages/normdocument/index.vue' /* webpackChunkName: "pages/normdocument/index" */))
const _7eef1ee2 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _147e2fcc = () => interopDefault(import('../pages/skladi/index.vue' /* webpackChunkName: "pages/skladi/index" */))
const _4da5a70e = () => interopDefault(import('../pages/cart/success/index.vue' /* webpackChunkName: "pages/cart/success/index" */))
const _4a315ac9 = () => interopDefault(import('../pages/normdocument/_slug.vue' /* webpackChunkName: "pages/normdocument/_slug" */))
const _a148987a = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _1fa7244f = () => interopDefault(import('../pages/vacancy/_slug.vue' /* webpackChunkName: "pages/vacancy/_slug" */))
const _2f9fbb7c = () => interopDefault(import('../pages/catalog/_.vue' /* webpackChunkName: "pages/catalog/_" */))
const _5db204b8 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/articles/:slug",
    components: {
      default: _43c1e4c5
    }
  }, {
    path: "/articles",
    components: {
      default: _4578860d
    }
  }, {
    path: "/cart",
    component: _45513a1a,
    pathToRegexpOptions: {"strict":true},
    name: "cart"
  }, {
    path: "/catalog",
    component: _238d7bb5,
    pathToRegexpOptions: {"strict":true},
    name: "catalog"
  }, {
    path: "/news",
    component: _4578860d,
    pathToRegexpOptions: {"strict":true},
    name: "news"
  }, {
    path: "/normdocument",
    component: _4be7fc11,
    pathToRegexpOptions: {"strict":true},
    name: "normdocument"
  }, {
    path: "/search",
    component: _7eef1ee2,
    pathToRegexpOptions: {"strict":true},
    name: "search"
  }, {
    path: "/skladi",
    component: _147e2fcc,
    pathToRegexpOptions: {"strict":true},
    name: "skladi"
  }, {
    path: "/cart/success",
    component: _4da5a70e,
    pathToRegexpOptions: {"strict":true},
    name: "cart-success"
  }, {
    path: "/news/:slug",
    component: _43c1e4c5,
    pathToRegexpOptions: {"strict":true},
    name: "news-slug"
  }, {
    path: "/normdocument/:slug",
    component: _4a315ac9,
    pathToRegexpOptions: {"strict":true},
    name: "normdocument-slug"
  }, {
    path: "/product/:slug?",
    component: _a148987a,
    pathToRegexpOptions: {"strict":true},
    name: "product-slug"
  }, {
    path: "/vacancy/:slug?",
    component: _1fa7244f,
    pathToRegexpOptions: {"strict":true},
    name: "vacancy-slug"
  }, {
    path: "/catalog/*",
    component: _2f9fbb7c,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-all"
  }, {
    path: "/*",
    component: _5db204b8,
    pathToRegexpOptions: {"strict":true},
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
